import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledContainerProps {
  containerColor?: string;
}

/**
 * Pill-shaped container that wraps a primary Chip and an optional secondary element.
 */
export const StyledContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'containerColor',
})<StyledContainerProps>(({ theme, containerColor }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  borderRadius: '16px',
  backgroundColor: containerColor ?? theme.palette.action.selected,

  '& .MuiChip-root': {
    minWidth: 74,
  },

  // Secondary element wrapper
  '& .CompoundChip-secondary': {
    display: 'inline-flex',
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      fontSize: '0.875rem',
      color: theme.palette.text.secondary,
    },
  },
  '& .CompoundChip-secondary-start': {
    marginLeft: theme.spacing(1),
  },
  '& .CompoundChip-secondary-end': {
    marginRight: theme.spacing(1),
  },
}));
